import { createContext } from "react";
import { IAuth } from "../interface/IAuth";

export const AuthContext = createContext<IAuth>(null!);